import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {




  constructor(private router: Router) {
    this.applyDeviceLayoutClass();
    const bootMark = (window as any).__oeBootMark;
    if (typeof bootMark === 'function') {
      bootMark('ngboot');
    }
    const loadDeferred = (window as any).__oeLoadDeferredThirdParty;
    if (typeof loadDeferred === 'function') {
      loadDeferred();
    }
    // Listen to router events to clear localStorage when navigating back to welcome page
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     if (this.router.url === '/') {
    //       localStorage.removeItem('hasContinued');
    //       this.isContinueButtonVisible = true;
    //     }
    //   }
    // });



  }
  ngOnInit(): void {
    this.applyDeviceLayoutClass();
    window.addEventListener('orientationchange', () => this.applyDeviceLayoutClass());

    const bootMark = (window as any).__oeBootMark;
    const trackScript = (el: HTMLScriptElement, ok: string, fail: string) => {
      if (typeof bootMark !== 'function') {
        return;
      }
      el.addEventListener('load', () => bootMark(ok));
      el.addEventListener('error', () => bootMark(fail, el.src));
    };

    if (environment.loadBureauMaxmindCdn) {
      const bureauScript = document.createElement('script');
      bureauScript.src = environment.bureau.script;
      bureauScript.async = true;
      bureauScript.type = 'text/javascript';
      trackScript(bureauScript, 'bu_ok', 'bu_fail');
      document.body.appendChild(bureauScript);
    }
    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe((event: NavigationEnd) => {
    //   this.showResearchDefender = !event.url.includes('/survey/survey-start');
    // });
    //this.checkContinueButtonState();
  }

  private applyDeviceLayoutClass(): void {
    const screenMin = Math.min(window.screen.width || 0, window.screen.height || 0);
    document.body.classList.toggle('device-phone', screenMin > 0 && screenMin <= 500);
  }

}
